import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '/api';
const MEDALS = ['🥇','🥈','🥉'];

export default function Ranking() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/ranking?limit=50`)
      .then(r => setRows(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container" style={{padding:'32px 20px'}}>
      <h2 className="section-title">🏆 Classement <span>général</span></h2>
      <div className="card">
        {loading ? <div className="spinner" /> : rows.length === 0
          ? <div className="empty">Aucun joueur encore</div>
          : rows.map((r, i) => (
            <div key={r.user_id} className="rank-row">
              <div className={`rank-num ${i < 3 ? 'top' : ''}`}>
                {i < 3 ? MEDALS[i] : i+1}
              </div>
              <div>
                <div className="rank-name">{r.name}</div>
                <div style={{fontSize:12,color:'var(--muted)'}}>
                  {r.username ? `@${r.username}` : ''} · {r.pronos} prono{r.pronos>1?'s':''}
                </div>
              </div>
              <div className="rank-acc">{r.accuracy}% exacts</div>
              <div className="rank-pts">{r.points} <span style={{fontSize:13,color:'var(--muted)'}}>pts</span></div>
            </div>
          ))
        }
      </div>
    </div>
  );
}
